import axios from "axios";
import { createOrderIdRoute, verifyPaymentRoute } from "../common/endpoints";

export const createOrderId = async (orderData) => {
  var config = {
    method: "post",
    url: createOrderIdRoute,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(orderData),
  };

  var orderIdResponse;
  await axios(config)
    .then((response) => {
      orderIdResponse = response;
    })
    .catch((error) => {
      console.log(error);
      orderIdResponse = error.response;
    });
  return orderIdResponse;
};

export const verifyPayment = async (verificationData) => {
  var config = {
    method: "post",
    url: verifyPaymentRoute,
    timeout: 0,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(verificationData),
  };

  var verifyResponse;
  await axios(config)
    .then((response) => {
      verifyResponse = response;
    })
    .catch((error) => {
      console.log(error);
      verifyResponse = error.response;
    });
  return verifyResponse;
};
